// Follow-up is a calendar date: do not shift it into the browser's timezone.
export const followUpDateInput = (value?: string | null) => {
  const date = String(value || "").slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : "";
};

export const formatFollowUpDate = (value?: string | null) => {
  const date = followUpDateInput(value);
  return date ? date.split("-").reverse().join("/") : "-";
};
